<app-page-header
    title="Gestión de Entidades"
    mobileTitle="Entidades"
    icon="fas fa-building"
    [showBack]="showMobileDetail"
    [unifiedOnMobile]="showMobileDetail"
    (back)="closeDetail()">
    @if (appSettings.isMobile() && !showMobileDetail && perm.canCurrent('canCreate')) {
        <button headerExtra type="button" class="btn btn-primary btn-xs" (click)="createNewEntity()">
            <i class="fas fa-plus me-1"></i>Nuevo
        </button>
    }
</app-page-header>

@if (!showMobileDetail) {
<app-mobile-footer [visible]="appSettings.isMobile()">
    <input type="search"
           class="form-control mobile-footer-search"
           placeholder="Buscar código, nombre, campus o correo..."
           [ngModel]="mobileSearch"
           (ngModelChange)="onSearchTerm($event)">
</app-mobile-footer>

<div [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()" [class.mb-3]="!appSettings.isMobile()"
     [class.border-0]="!appSettings.isMobile()" [class.shadow-sm]="!appSettings.isMobile()"
     [class.mobile-requests-container]="appSettings.isMobile()">
    @if (!appSettings.isMobile()) {
    <div class="row align-items-end g-3">
        <div class="col-md-6">
            <label class="form-label fw-bold small text-uppercase text-muted">Buscar entidad</label>
            <ng-select
                [items]="searchItems()"
                bindLabel="label"
                bindValue="id"
                [ngModel]="selectedId()"
                (ngModelChange)="onSearchSelect($event)"
                (search)="onSearchTerm($event)"
                [clearable]="true"
                placeholder="Código, nombre, campus o correo">
            </ng-select>
        </div>
        <div class="col-md-6 text-end">
            @if (perm.canCurrent('canCreate')) {
            <button class="btn btn-primary btn-sm" (click)="createNewEntity()">
                <i class="fas fa-plus me-1"></i> Nueva Entidad
            </button>
            }
        </div>
    </div>
    }
    <div class="entities-list-shell" [class.mt-3]="!appSettings.isMobile()">
        <app-entities-list
            [entities]="filteredEntities()"
            [isLoading]="catalogService.loading()"
            (edit)="openEdit($event)" />
    </div>
</div>
} @else {
<div class="panel p-3 mb-3">
    <h5 class="mb-3">{{ mode() === formMode.CREATE ? 'Nueva entidad' : 'Editar entidad' }}</h5>
    <app-entity-form [entityForm]="entityForm" [(mode)]="mode" (formChange)="handleFormChange($event)">
    </app-entity-form>
</div>
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="entityForm.invalid"
        (click)="saveFromModal()">
        Guardar
    </button>
</app-mobile-footer>
}

<ng-template #entityModal let-d="dismiss">
    <div class="modal-header border-bottom-0">
        <h5 class="modal-title fw-bold">
            {{ mode() === formMode.CREATE ? 'Nueva entidad' : 'Editar entidad' }}
        </h5>
        <button type="button" class="btn-close" (click)="d()"></button>
    </div>
    <div class="modal-body">
        <app-entity-form [entityForm]="entityForm" [(mode)]="mode" (formChange)="handleFormChange($event)">
        </app-entity-form>
    </div>
    <div class="modal-footer border-top-0">
        <button type="button" class="btn btn-white btn-sm" (click)="d()">Cancelar</button>
        <button type="button"
                class="btn btn-primary btn-sm"
                [disabled]="entityForm.invalid"
                (click)="saveFromModal()">
            <i class="fas fa-save me-1"></i> Guardar
        </button>
    </div>
</ng-template>
